"use strict";

function slider() {
  var el = document.querySelector('.c-slider__products');
  if (!el) {
    return;
  }

  var swiper = new Swiper(el, {
    loop: true,
    autoplay: true,
    effect: 'fade',
    pagination: {
      el: ".c-slider__pagination",
      clickable: true,
      renderBullet: function (index, className) {
        // Fix: Use originalSlides instead of cloned ones
        var realSlides = this.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
        var slide = realSlides[index];

        // Fallback if something went wrong
        if (!slide) return '<span class="' + className + '">•</span>';

        // Extract data from the real slide
        var link = slide.querySelector('a');
        var url = link ? link.getAttribute('href') : '#';

        var color = slide.dataset.color || '#F1B434';
        var umf = slide.dataset.paginationText || slide.dataset.name || 'Manuka Honey';

        return '<span style="--product-color:' + color + ';" ' +
               'class="c-slider__pagination__bullet ' + className + '" ' +
               'data-url="' + url + '">' + umf + '</span>';
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  // Pagination bullets switch slides only — they no longer navigate to the
  // product. The winning A/B variant relied on the UMF labels being a filter
  // for the slider, not a set of links off the homepage. The bullets keep
  // their data-url so the markup is unchanged for anything else reading it.

  // Jump to a specific slide if needed
  swiper.slideToLoop(6, 0, false); // 7th real slide, loop-safe
  swiper.autoplay.start();
}

slider();